export default __webpack_public_path__ + "media/images/the-pumpkin-run-e4f78eb12ef521eb3a455abf149c3220.png";